"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterSection = void 0;
var _footerModule = _interopRequireDefault(require("@albelli/arc-3/lib/footer.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Grid = require("../Grid");
var _FooterItem = require("./FooterItem");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FooterSection = _ref => {
  let {
    index,
    text,
    items,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Grid.Grid, {
    cell: true,
    column: 3,
    columnTablet: 6,
    columnPhone: 4
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: _footerModule.default["arc3-footer__title"]
  }, text), !!items && /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)("arc3-typo-ul-no-style", _footerModule.default["arc3-footer__anchor"], _footerModule.default[className] || className)
  }, items.map((i, j) => /*#__PURE__*/_react.default.createElement(_FooterItem.FooterItem, _extends({
    key: j
  }, i)))));
};
exports.FooterSection = FooterSection;